import React, { useEffect, useState } from "react";
import { socket } from '../../../helpers/global_helper';

import Dred1 from "../../../../src/assets/images/dice/red1.svg";
import Dred2 from "../../../../src/assets/images/dice/red2.svg";
import Dred3 from "../../../../src/assets/images/dice/red3.svg";
import Dred4 from "../../../../src/assets/images/dice/red4.svg";
import Dred5 from "../../../../src/assets/images/dice/red5.svg";
import Dred6 from "../../../../src/assets/images/dice/red6.svg";

import Dblack1 from "../../../../src/assets/images/dice/black1.svg";
import Dblack2 from "../../../../src/assets/images/dice/black2.svg";
import Dblack3 from "../../../../src/assets/images/dice/black3.svg";
import Dblack4 from "../../../../src/assets/images/dice/black4.svg";
import Dblack5 from "../../../../src/assets/images/dice/black5.svg";
import Dblack6 from "../../../../src/assets/images/dice/black6.svg";
import { withTranslation } from "react-i18next";

const PockerDice = (props) => {

    const roomColorNumber = {
        'PD': {
            "1": {
                "1": Dred1,
                "2": Dred2,
                "3": Dred3,
                "4": Dred4,
                "5": Dred5,
                "6": Dred6,
            },
            "2": {
                "1": Dblack1,
                "2": Dblack2,
                "3": Dblack3,
                "4": Dblack4,
                "5": Dblack5,
                "6": Dblack6,
            }
        },
        'PD -NEW': {
            "1": {
                "1": Dred1,
                "2": Dred2,
                "3": Dred3,
                "4": Dred4,
                "5": Dred5,
                "6": Dred6,
            },
            "2": {
                "1": Dblack1,
                "2": Dblack2,
                "3": Dblack3,
                "4": Dblack4,
                "5": Dblack5,
                "6": Dblack6,
            }
        }
    };
    const [result, setResult] = useState([]);
    useEffect(() => {
        socket.on("game_history", (result) => {
            if (result.room_id == props.room_id) {
                if (result.status != 'success') {
                    return;
                }
                let temp = [];
                let distributed_data = [];
                let distributed_color = [];
                for (let i = 0; i < result.results.length; i++) {
                    if (!temp[i])
                        temp[i] = {};
                    if (!temp[i]['data'])
                        temp[i]['data'] = [];
                    if (!distributed_data[i])
                        distributed_data[i] = [];
                    if (!distributed_color[i])
                        distributed_color[i] = [];
                    for (let j = 0; j < result.results[i].length; j++) {
                        let t = result.results[i][j].split("");
                        temp[i]['data'].push(t);
                        distributed_data[i].push(parseInt(t[0]));
                        distributed_color[i].push(parseInt(t[1]));
                    }
                    temp[i]['label'] = 'pending';
                }
                let firstStraight = "1,2,3,4,5";
                let secondStraight = "2,3,4,5,6";
                for (let i = 0; i < temp.length; i++) {
                    let t_distributed_data = [...distributed_data[i]];
                    let t_distributed_color = [...distributed_color[i]];
                    let similarCount = {};
                    for (let j = 0; j < t_distributed_data.length; j++) {
                        similarCount[t_distributed_data[j]] = similarCount[t_distributed_data[j]] ? similarCount[t_distributed_data[j]] + 1 : 1;
                    }

                    if (t_distributed_data.length == 5) {
                        let uniqueData = [...new Set(t_distributed_data)];
                        let uniqueColor = [...new Set(t_distributed_color)];
                        if (uniqueData.length == 1) {
                            temp[i]['label'] = '5 of a kind';
                        }
                        else if ((uniqueColor.length == 1)
                            && (t_distributed_data.toString() == firstStraight || t_distributed_data.toString() == secondStraight)) {
                            temp[i]['label'] = 'Straight Flush';
                        }
                        else if (uniqueData.length == 5 && uniqueColor.length == 1) {
                            temp[i]['label'] = 'Inc Straight Flush';
                        }
                        else if (temp[i]['label'] == 'pending') {
                            for (let key in similarCount) {
                                if (similarCount[key] == 4) {
                                    temp[i]['label'] = '4 of a kind';
                                    break;
                                }
                            }
                        }
                        if (temp[i]['label'] == 'pending' && (t_distributed_data.toString() == firstStraight || t_distributed_data.toString() == secondStraight)) {
                            temp[i]['label'] = 'Straight';
                        }
                        if (temp[i]['label'] == 'pending' && uniqueData.length == 2) {
                            temp[i]['label'] = 'Full house';
                        }
                        if (temp[i]['label'] == 'pending' && uniqueColor.length == 1) {
                            temp[i]['label'] = 'Flush';
                        }
                        if (temp[i]['label'] == 'pending' &&
                            (uniqueData.length == 5
                                && uniqueColor.length !== 1
                                && t_distributed_data.toString() !== firstStraight && t_distributed_data.toString() !== secondStraight)) {
                            temp[i]['label'] = 'Inc Straight';
                        }
                        if (temp[i]['label'] == 'pending') {
                            for (let key in similarCount) {
                                if (similarCount[key] == 3) {
                                    temp[i]['label'] = '3 of a kind';
                                    break;
                                }
                            }
                        } if (temp[i]['label'] == 'pending') {
                            let pairCount = 0;
                            for (let key in similarCount) {
                                if (similarCount[key] == 2) {
                                    pairCount++;
                                }
                            }
                            if (pairCount == 2) {
                                temp[i]['label'] = '2 Pairs';
                            }
                            else if (pairCount == 1) {
                                temp[i]['label'] = '1 Pair';
                            } else
                                temp[i]['label'] = 'No Luck';
                        }
                    }
                }
                // }
                setResult([...temp]);
            }
        });
    }, []);

    useEffect(() => {
        socket.emit("game_history", { room_id: props.room_id });
    }, [props.room_id]);

    return (
        <div className='pd_history_wrapper'>
            {/* <p className='pd_title1'>{props.t("game_history")}</p> */}
            <div className='pd_history_main'>
                {result.length > 0 && result.map((obj, index) => {
                    return (
                        <div className='pd_history_row' key={index}>
                            <div className='pd_dice_list'>
                                {obj['data'] && obj['data'].length > 0 && obj['data'].map((inArr, inInd) => {
                                    return (
                                        <div className='pd_dice' key={inInd}>
                                            <img src={roomColorNumber[props.game_code][inArr[1]][inArr[0]]} alt='' />
                                        </div>
                                    )
                                })}
                            </div>
                            <p className='pd_title'>{obj.label}</p>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default withTranslation()(PockerDice)